import Mapper from '@/models/mappers/Mapper';
import { ImageFile } from '@/models/entities/ImageFile';
import { ImageFileDTO } from '@/api/dto/ImageFileDTO';
import { mapValueToInterface } from '@/utils/models';

export class ImageFileMapper extends Mapper<ImageFile, ImageFileDTO> {
  mapFromDTO(imageFileDTO: ImageFileDTO): ImageFile {
    return new ImageFile(<Partial<ImageFile>>imageFileDTO);
  }

  mapToDTO(imageFile: ImageFile): ImageFileDTO {
    return mapValueToInterface(imageFile) as ImageFileDTO;
  }
}
